import React from "react";
import {IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip} from '@mui/material';
import DeleteIcon from "@mui/icons-material/Delete";
import {Artwork} from "../types/artwork";

type Props = {
    artworks: Artwork[];
    onDelete: (id: string) => void; // ✅ Ajout obligatoire
    onEdit: (artwork: Artwork) => void;
};

const ArtworkTable: React.FC<Props> = ({artworks, onDelete, onEdit}) => (
    <TableContainer component={Paper} sx={{mt: 3}}>
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>Titre</TableCell>
                    <TableCell>Artiste</TableCell>
                    <TableCell>Année</TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell align="right">Actions</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {artworks.map((artwork) => (
                    <TableRow
                        key={artwork.uuid}
                        hover
                        onClick={() => onEdit(artwork)}
                        sx={{cursor: 'pointer'}}
                    >
                        <TableCell>{artwork.title}</TableCell>
                        <TableCell>{artwork.artist}</TableCell>
                        <TableCell>{artwork.year}</TableCell>
                        <Tooltip title={artwork.description ?? ''}>
                            <TableCell sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 300 }}>
                                {artwork.description}
                            </TableCell>
                        </Tooltip>
                        <TableCell align="right">
                            <IconButton
                                color="error"
                                onClick={(e) => {
                                    e.stopPropagation(); // Empêche la propagation du clic
                                    if (window.confirm(`Êtes-vous sûr de vouloir supprimer "${artwork.title}" ?`)) {
                                        onDelete(artwork.uuid);
                                    }
                                }}
                            >
                                <DeleteIcon/>
                            </IconButton>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </TableContainer>
);

export default ArtworkTable;
